// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"A9 uX","wrapperNeon":"A- u9","ribbon":"A_ u6","title":"Ba uZ","seasons":"Bb u4","genres":"Bc u5","buttonWrapper":"Bd u1","button":"Be u2","buttonNeon":"Bf u-"};